import { render, staticRenderFns } from "./InviteParticipant.vue?vue&type=template&id=2af6ed08&scoped=true&"
import script from "./InviteParticipant.vue?vue&type=script&lang=js&"
export * from "./InviteParticipant.vue?vue&type=script&lang=js&"
import style0 from "./InviteParticipant.vue?vue&type=style&index=0&id=2af6ed08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af6ed08",
  null
  
)

export default component.exports